import { ApiProblemError, NOT_PROVISIONED_CODE, REVOKED_CODE } from '@taler/api-client'

const SESSION_ENDED_CODES: ReadonlySet<string> = new Set([REVOKED_CODE, 'auth.session_revoked'])

export type TerminalFailure = 'not-provisioned' | 'sign-in-again'

/** Auth failures no screen-level retry can fix; they route away instead of showing Try again. */
export function terminalFailureOf(error: unknown): TerminalFailure | undefined {
  if (!(error instanceof ApiProblemError)) return undefined
  if (error.code === NOT_PROVISIONED_CODE) return 'not-provisioned'
  return SESSION_ENDED_CODES.has(error.code) ? 'sign-in-again' : undefined
}
